import gql from 'graphql-tag'

const deleteWorkExperienceMutation = gql`
  mutation deleteWorkExperience($id: String!) {
    deleteWorkExperience(id: $id)
  }
`

export default deleteWorkExperienceMutation
